import { Routes, Route } from 'react-router-dom';
import { IndexPage } from './pages/IndexPage';
import { CustomersReportPage } from './pages/CustomersReportPage';
import { OrdersReportPage } from './pages/OrdersReportPage';
import { InvoicesReportPage } from './pages/InvoicesReportPage';
import { SubscriptionsReportPage } from './pages/SubscriptionsReportPage';
import { PaymentsReportPage } from './pages/PaymentsReportPage';

export const ReportsLayout = () => {
  return (
    <Routes>
      <Route index element={<IndexPage />} />
      <Route path="customers" element={<CustomersReportPage />} />
      <Route path="orders" element={<OrdersReportPage />} />
      <Route path="invoices" element={<InvoicesReportPage />} />
      <Route path="subscriptions" element={<SubscriptionsReportPage />} />
      <Route path="payments" element={<PaymentsReportPage />} />
    </Routes>
  );
};